import type { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import type { FacetValue, FacetValuesResponse } from './facetValues.types'

const ENDPOINT = 'v1/opportunities-search/facet-values'

export const getCityFacetValues: QueryFn<[string, string], FacetValue[]> = async (client, [_, query]) => {
  const { data } = await client.post<FacetValuesResponse>(ENDPOINT, { field: 'city', query }, { withCredentials: true })

  return data.facetValues
}
